
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-vista-blue text-white hover:bg-vista-dark-blue",
        secondary:
          "border-transparent bg-vista-soft-blue text-vista-blue hover:bg-vista-soft-blue/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-vista-blue border-vista-blue",
        purple: "border-transparent bg-vista-purple text-white hover:bg-vista-purple/90",
        'light-blue': "border-transparent bg-vista-light-blue text-white hover:bg-vista-light-blue/90",
        'medium-blue': "border-transparent bg-vista-medium-blue text-white hover:bg-vista-medium-blue/90",
        'light-purple': "border-transparent bg-vista-light-purple text-vista-dark-gray hover:bg-vista-light-purple/90",
        'soft-blue': "border-transparent bg-vista-soft-blue text-vista-blue hover:bg-vista-soft-blue/80",
        lime: "border-transparent bg-[#047857] text-white hover:bg-[#065F46]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
